// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import {defineStore, storeToRefs} from 'pinia'
import {config} from "@/core/config";
import {searchLogger, searchErrorLogger} from "@/core/Logger";
import {AggregationInterface, FilterRangeInterface} from "@/core/types";
import {useUrlStore} from '@/store/SerpPage/UrlStore'
import {useSerpResultsStore} from '@/store/SerpPage/SerpResultsStore'
import {usePaginationStore} from "@/store/SerpPage/PaginationStore";
import {SmartSearchConfig} from "@/main";
import {useSortingStore} from "@/store/SerpPage/SortingStore";
import {useSearchQueryStore} from "@/store/SearchQueryStore";
import {useMobileViewStore} from "@/store/MobileViewStore";

const {apiHost, customerSymbol, searchId, apiKey} = config


export const useFiltersStore = defineStore('FiltersStore', {
  state: () => {
    return {
      aggregations: [] as AggregationInterface[],
      activeFilters: {},
      isLoading: false,
      canShowFiltersOnMobile: false,
      activeRangeFilters: {},
      rangeFilters: {}
    }
  },
  getters: {
    getFilters(state): Array<AggregationInterface> {
      return state.aggregations.filter((item) => {
        return item?.data?.values?.length > 0 || item.data.min || item.data.max
      })
    },
    getFiltersToTagList() {
      const {limitPerFilter} = SmartSearchConfig.value.serp.tagList;
      const activeFilters = this.getActiveFilters;
      
      return this.getCheckboxFilters.flatMap(filter =>
        filter.data.values
          .filter(value =>
            // Sprawdź, czy dana wartość nie znajduje się w aktywnych filtrach
            !(activeFilters[filter.field] && activeFilters[filter.field].includes(value.label))
          )
          .slice(0, limitPerFilter)
          .map(value => ({
            field: filter.field,
            label: filter.label,
            value
          }))
      );
    },
    
    getCheckboxFilters(state): Array<AggregationInterface> {
      return state.aggregations.filter((item) => {
        return item.type === 'checkbox'
      })
    },
    hasAnyFilters(state): number {
      return state.aggregations.length > 0
    },
    getFiltersLength(state): number {
      return state.aggregations.length
    },
    getActiveFilters(state) {
      return state.activeFilters
    },
    hasSelectedFilters(state) {
      return Object.keys(state.activeFilters).length > 0
    },
    getIsLoading(state) {
      return state.isLoading
    },
    getRangeInputs(state) {
      return state.rangeInputs
    },
    
    
  },
  actions: {
    setBodyScroll(allow: boolean) {
      if (allow) {
        document.body.classList.remove('no-scroll');
      } else {
        document.body.classList.add('no-scroll');
      }
    },
    showFiltersOnMobile() {
      this.canShowFiltersOnMobile = true
    },
    hideFiltersOnMobile() {
      this.canShowFiltersOnMobile = false
    },
    getFilterUnit(fieldName: string) {
      return this.aggregations.find(aggregate => aggregate.field === fieldName).data.unit
    },
    getFilterLabelByFilterName(fieldName: string): AggregationInterface {
      return this.aggregations.find(aggregate => aggregate.field === fieldName)?.label;
    },
    filterIsChecked(field: string, label: string) {
      const filterValue = this.getActiveFilters[field] as Array<string>;
      return filterValue?.includes(label) ?? false;
    },
    setActiveFilters(activeFilters): void {
      this.activeFilters = activeFilters
    },
    async updateCategoryItem(field: string, label: string) {
      await this.updateFilter(field, label)
    },
    updateRegisteredFilter(filterName: string, filterType: 'minValue' | 'maxValue', newValue: number | null) {
      if (this.rangeFilters[filterName]) {
        
        this.rangeFilters[filterName][filterType] = newValue
      }
      searchLogger.log(`updateRegisteredFilter ${filterName}.${filterType}`, newValue)
    },
    registerFilter(filterName: string, filterData: FilterRangeInterface) {
      this.rangeFilters[filterName] = filterData
      searchLogger.log(`registerFilter ${filterName}`, filterData)
    },
    
    registerAsActiveFilter(filterName: string, filterData: FilterRangeInterface) {
      this.activeRangeFilters[filterName] = filterData
      searchLogger.log(`registerAsActiveFilter ${filterName}`, filterData)
    },
    
    async updateRangeValue(e: Event, field: string, filterData: FilterRangeInterface, minValue, maxValue) {
      if (minValue < 0 || maxValue < 0) {
        return
      }
      
      await this.updateRangeFilter(field, minValue, maxValue);
    },
    
    async updateRangeFilter(field: string, min: number, max: number) {
      if ((!min && !max) || (min && max && min > max) || (min && max && max < min)) {
        return
      }
      
      const paginationStore = usePaginationStore();
      const urlStore = useUrlStore()
      const url = urlStore.decomposeUrl();
      
      const rangeData = {}
      if (min) {
        rangeData.min = Number(min)
      }
      if (max) {
        rangeData.max = Number(max)
      }
      
      urlStore.addRangeFiltersToParameters(url, field, rangeData)
      this.activeFilters[field] = rangeData;
      
      paginationStore.resetPageValue(url)
      urlStore.updateUrl(url);
      await this.fetchFiltersAnProducts()
      
    },
    
    clearInputValues(filterName: string): void {
      this.updateRegisteredFilter(filterName, 'minValue', this.rangeFilters[filterName]?.min)
      this.updateRegisteredFilter(filterName, 'maxValue', this.rangeFilters[filterName].max)
    },
    async removeRangeFilter(filterName: string) {
      
      const urlStore = useUrlStore()
      const paginationStore = usePaginationStore()
      const serpResultsStore = useSerpResultsStore()
      const url = urlStore.decomposeUrl();
      urlStore.removeRangeFilterFromParameters(url, filterName)
      
      paginationStore.resetPageValue(url)
      urlStore.updateUrl(url);
      
      await this.fetchFiltersAnProducts()
      serpResultsStore.scrollIntoView()
    },
    
    
    async updateFilter(field: string, label: string) {
      
      const paginationStore = usePaginationStore();
      const urlStore = useUrlStore()
      const filterValue = [...(this.activeFilters[field] as Array<string> || [])];
      const filterIsChecked = this.filterIsChecked(field, label)
      
      const url = urlStore.decomposeUrl();
      
      if (filterIsChecked) {
        filterValue.splice(filterValue.indexOf(label), 1);
      } else {
        filterValue.push(label);
      }
      
      urlStore.updateFiltersParameters(url, field, filterValue)
      
      this.activeFilters[field] = filterValue;
      paginationStore.resetPageValue(url)
      
      urlStore.updateUrl(url);
      await this.updateFilters()
      
      
    },
    async updateFilters() {
      await this.fetchFiltersAnProducts()
    },
    async fetchAll(){
      const serpResultsStore = useSerpResultsStore()
      await Promise.all([
        serpResultsStore.getAndSetProducts('changeFilter'),
        this.fetchFilters()
      ])
    },
    
    async fetchFiltersAnProducts() {
      if(window?._QONizer?.customSmartSearchConfig?.skipFetchFilters){
        searchLogger.log('! skipping Fetch Filters to allow multiple filters')
       
        const serpResultsStore = useSerpResultsStore()
        await Promise.all([
          serpResultsStore.getAndSetProducts('changeFilter'),
        ])
        return
      }
      searchLogger.log('Fetching with filters')
      await this.fetchAll()
      
    },
    clearFilterValues() {
      this.activeRangeFilters = {}
    },
    
    async clearSelectedFilters() {
      const serpResultsStore = useSerpResultsStore()
      const mobileViewStore = useMobileViewStore()
      const urlStore = useUrlStore()
      this.activeFilters = {};
      
      urlStore.removeFiltersFromUrl()
      // this.clearFilterValues()
      // this.hideFiltersOnMobile()
      await this.fetchFiltersAnProducts()
      if (!mobileViewStore.isMobileView) {
        serpResultsStore.scrollIntoView()
      }
    },
    
    getSearchQueryParams(url: URL): URL {
      const urlParams = useSearchQueryStore().getSearchParams()
      const searchQuery = useSearchQueryStore().getSearchQuery
      
      const sortingStore = useSortingStore();
      const {selectedSort} = storeToRefs(sortingStore)
      const paginationStore = usePaginationStore()
      const {page} = storeToRefs(paginationStore)
      page.value !== 0 && url.searchParams.set('p', page.value)
      urlParams.forEach((value, key) => {
        if (key.match(/^f/)) {
          url.searchParams.set(key, value);
        }
      });
      
      searchQuery && url.searchParams.set('q', searchQuery)
      url.searchParams.set('s', selectedSort.value)
      return url
    },
    
    async fetchFilters(source = 'unknown'): Promise<void> {
      const searchQuery = useSearchQueryStore().getSearchQuery
      searchLogger.log('fetchFilters SearchQuery ', searchQuery)
      
      const {allowEmptyQuery} = SmartSearchConfig.value.serp.query
      
      if (!allowEmptyQuery && !searchQuery) {
        searchLogger.log('Not allowed to show filters on empty query')
        return
      }
      let url = new URL(`https://${apiHost}/restapi/${customerSymbol}/search/${searchId}/aggregations`)
      url = this.getSearchQueryParams(url)
      searchLogger.log(`fetchFilters url ${source}: ${url.toString()}`)
      
      
      
      const config = {
        headers: {
          'Api-key': apiKey
        },
        credentials: 'include'
      }
      
      try {
        this.isLoading = true
        const response = await fetch(
          url.toString(),
          config
        );
        
        if (!response.ok) {
          this.isLoading = false
          throw new Error('Network response was not ok');
          
        }
        
        const {aggregations} = await response.json();
        
        this.aggregations = aggregations
        this.isLoading = false
        
      } catch (error) {
        this.isLoading = false
        searchErrorLogger.log('Error fetching filters:', error);
      }
    }
  },
})
